import { render } from "./SliderComponent.vue?vue&type=template&id=739a4977"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__